import type { ShapePoints } from "./pointTypes";

// TODO: try a smoother shape?
// TODO: work out how to get the Knights to face the right way
export const horseNeckAndHead: ShapePoints = [
  { x: 0.035, y: 0.08 },
  { x: 0.045, y: 0.16 },
  { x: 0.03, y: 0.19 },
  { x: 0.027, y: 0.2 },
  { x: 0.02, y: 0.19 },
  { x: -0.02, y: 0.185 },
  { x: -0.065, y: 0.17 },
  { x: -0.065, y: 0.1585 },
  { x: -0.0615, y: 0.155 },
  { x: -0.005, y: 0.155 },
  { x: -0.04, y: 0.08 },
];
